var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBoat = function SvgBoat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500.5 500.5",
    height: 500.5,
    width: 500.5,
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "invis boatShards",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    "data-id": 0,
    d: "M268.325 358.557l-140.428 9.025 106.882 19.537z",
    fill: "#c00"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 1,
    d: "M127.897 367.582l106.882 19.537-76.2 2.337z",
    fill: "#c00"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 2,
    d: "M428.259 354.75l-27.015.267 4.975 12.387z",
    fill: "#c00"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 3,
    d: "M12.652 379.489l115.245-11.907-50.598 17.459z",
    fill: "#c00"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 4,
    d: "M234.78 387.12l33.005-1.011.54-27.552z",
    fill: "#c00"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 5,
    d: "M284.882 357.96h-4.589l4.59 9.444z",
    fill: "#c00"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 6,
    d: "M374.548 367.403l-11.363 13.318 36.342-5.576z",
    fill: "#c00"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 7,
    d: "M267.763 387.66l11.542-81.293 1.646 85.956z",
    fill: "#6a3200"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 8,
    d: "M90.456 451.37l21.874 12.677 72.136-36.74z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 9,
    d: "M267.763 387.66l1.934-99.106 9.608 17.813z",
    fill: "#6a3200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.412 384.037l-176.834 5.419 223.151 28.95z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 11,
    d: "M184.466 427.306l19.59 16.236 65.032-39.75z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 12,
    d: "M244.492 457.542l-40.437-14 65.033-39.75z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 13,
    d: "M279.305 306.367l-1.69-127.712-7.918 109.9z",
    fill: "#6a3200"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 15,
    d: "M269.088 403.792l18.63 48.294 37.363-41.03z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 16,
    d: "M376.8 456.176l49.224-1.174-44.296-36.596z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 17,
    d: "M295.973 459.57l3.621-20.527 21.098 3.649z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 18,
    d: "M269.696 288.556l2.998-152.899 4.922 42.998z",
    fill: "#6a3200"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 19,
    d: "M277.616 178.655L275.293 3.064l-2.599 132.593z",
    fill: "#6a3200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.926 311.893l-50.17 4.035 15.534 51.475z",
    fill: "#f1bfbf"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 21,
    d: "M333.755 315.928L283.99 299.97l.235 17.723z",
    fill: "#f1bfbf"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 22,
    d: "M362.836 259.38l-78.846 40.59 49.765 15.958z",
    fill: "#f1bfbf"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 26,
    d: "M305.123 206.962l-22.77-30.753.996 75.26z",
    fill: "#f1bfbf"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 27,
    d: "M280.818 60.155l21.57 48.71-20.945-1.398z",
    fill: "#f1bfbf"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 28,
    d: "M295.446 108.401l-13.093 67.81-.91-68.744z",
    fill: "#f1bfbf"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 29,
    d: "M322.9 159.942l-27.454-51.54 6.942.462z",
    fill: "#f1bfbf"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 30,
    d: "M305.123 206.962l17.778-47.02 20.618 51.338z",
    fill: "#f1bfbf"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 31,
    d: "M305.123 206.962l17.778-47.02-40.548 16.268z",
    fill: "#f1bfbf"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 32,
    d: "M282.353 176.21l13.089-67.818 27.459 51.55z",
    fill: "#f1bfbf"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 33,
    d: "M264.828 320.218h-47.645l14.103-45.872z",
    fill: "#f1bfbf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.185 263.148l2.403 57.069v.001h70.596z",
    fill: "#f1bfbf"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 38,
    d: "M171.198 284.267l60.088-9.92-14.102 45.871z",
    fill: "#f1bfbf"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 39,
    d: "M264.828 320.218l.684-34.914-34.226-10.958z",
    fill: "#f1bfbf"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 40,
    d: "M265.513 285.304l1.718-87.666-35.945 76.708z",
    fill: "#f1bfbf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.586 128.449l-78.204 20.316 76.848 48.873z",
    fill: "#f1bfbf"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 42,
    d: "M247.26 133.99l22.208-49.48-.88 43.939z",
    fill: "#f1bfbf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.018 4.404L224.006 87.62l45.442-3.062z",
    fill: "#f1bfbf"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 45,
    d: "M224.005 87.62l23.255 46.37 22.187-49.43z",
    fill: "#f1bfbf"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 49,
    d: "M190.382 148.767l11.463 58.195-44.802 2.434z",
    fill: "#f1bfbf"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 50,
    d: "M142.997 234.94l14.046-25.544 44.802-2.434z",
    fill: "#f1bfbf"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 51,
    d: "M144.185 263.15l57.66-56.188-58.848 27.978z",
    fill: "#f1bfbf"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 52,
    d: "M231.287 274.346l-53.589-43.855-6.5 53.776z",
    fill: "#f1bfbf"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 53,
    d: "M144.185 263.15l27.014 21.117 6.5-53.776z",
    fill: "#f1bfbf"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 54,
    d: "M201.845 206.962l65.386-9.324-76.848-48.871z",
    fill: "#f1bfbf"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 55,
    d: "M201.845 206.962l-24.147 23.535 53.588 43.85z",
    fill: "#f1bfbf"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 56,
    d: "M381.728 418.406l77.86-16.55-33.564 53.146z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 58,
    d: "M335.413 384.036l46.315 34.37 33.398-7.1z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.65 379.489l77.806 71.88L77.3 385.041z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 61,
    d: "M112.33 464.047L76.8 443.542l25.108 22.835z",
    fill: "#e5fbff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 63,
    d: "M158.579 389.456l25.887 37.85-94.01 24.063z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 64,
    d: "M184.466 427.306l84.622-23.515-110.508-14.335z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 69,
    d: "M184.466 427.306l.278 20.553-72.414 16.188z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 70,
    d: "M184.744 447.859l19.311-4.317-19.59-16.236z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 71,
    d: "M335.413 384.036l79.713 27.27-15.6-36.161z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3 385.04l13.157 66.33 68.12-61.914z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.23 197.638l-65.385 9.324 29.442 67.384z",
    fill: "#f1bfbf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.348 251.467l.642 48.504 78.846-40.592z",
    fill: "#f1bfbf"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 79,
    d: "M77.299 385.04l81.28 4.416-30.682-21.874z",
    fill: "#c00"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 80,
    d: "M284.882 367.403h26.497l-7.63 17.604z",
    fill: "#c00"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 81,
    d: "M311.38 367.403h33.897l-9.864 16.633z",
    fill: "#c00"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 82,
    d: "M345.277 367.403h29.271l-10.844 12.71z",
    fill: "#c00"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 83,
    d: "M303.749 385.007l7.63-17.603 24.034 16.632z",
    fill: "#c00"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 84,
    d: "M335.413 384.037l9.864-16.633 18.427 12.71z",
    fill: "#c00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.257 354.75l21.263 10.263 38.33-9.862z",
    fill: "#c00"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 87,
    d: "M449.521 365.013l-43.302 2.391 22.035-12.652z",
    fill: "#c00"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 57,
    d: "M415.126 411.306l34.395-46.293 10.066 36.842z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 88,
    d: "M406.219 367.403l-6.692 7.742-24.979-7.74z",
    fill: "#c00"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 59,
    d: "M459.587 401.855l28.262-46.704-38.328 9.862z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 89,
    d: "M284.882 367.403h31.683l-32.34-49.709z",
    fill: "#f1bfbf"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 90,
    d: "M316.567 367.403l17.188-51.475 15.534 51.475z",
    fill: "#f1bfbf"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 92,
    d: "M349.29 367.403h56.929l-22.293-55.51z",
    fill: "#f1bfbf"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 72,
    d: "M399.527 375.145l15.6 36.161 34.394-46.293z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 93,
    d: "M316.567 367.403l-32.342-49.709 49.53-1.764z",
    fill: "#f1bfbf"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 94,
    d: "M138.962 494.165l132.01-22.096-86.085-13.62z",
    fill: "#80edff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 95,
    d: "M208.145 462.128l79.572-10.042-39.507 16.381z",
    fill: "#4ce8ff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 96,
    d: "M95.759 467.751l108.296-24.209-73.237 56.958z",
    fill: "#b3f3ff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 97,
    d: "M256.17 465.167l96.61 5.563-74.66-14.664z",
    fill: "#1adfff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 98,
    d: "M295.973 459.57l79.339-7.031-51.738 12.454z",
    fill: "#0df"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 99,
    d: "M342.897 460.342s121.458 3.055 121.942 3.055c.485 0-103.873-7.403-103.873-7.403z",
    fill: "#00dcff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.219 367.403l-6.692 7.742 49.994-10.132z",
    fill: "#c00",
    stroke: "none",
    strokeOpacity: 1,
    paintOrder: "stroke fill markers",
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.882 367.403l-4.057 18.306-.532-27.75z",
    fill: "#c00",
    stroke: "none",
    strokeOpacity: 1,
    paintOrder: "stroke fill markers",
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.825 385.709l22.924-.702-18.867-17.603z",
    fill: "#c00",
    stroke: "none",
    strokeOpacity: 1,
    paintOrder: "stroke fill markers",
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.887 458.449l23.258 3.68-4.09-18.587z",
    fill: "red",
    stroke: "none",
    strokeOpacity: 1,
    paintOrder: "stroke fill markers",
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.145 462.128l-4.09-18.586 40.437 14z",
    fill: "red",
    stroke: "none",
    strokeOpacity: 1,
    paintOrder: "stroke fill markers",
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.492 457.542l24.596-53.75 18.63 48.294z",
    fill: "red",
    stroke: "none",
    strokeOpacity: 1,
    paintOrder: "stroke fill markers",
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.717 452.086l8.256 7.485 3.621-20.528z",
    fill: "red",
    stroke: "none",
    strokeOpacity: 1,
    paintOrder: "stroke fill markers",
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.12 456.066l9.597-3.98 8.256 7.485z",
    fill: "red",
    stroke: "none",
    strokeOpacity: 1,
    paintOrder: "stroke fill markers",
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.692 442.692l-2.063 14.87-22.656 2.009z",
    fill: "red",
    stroke: "none",
    strokeOpacity: 1,
    paintOrder: "stroke fill markers",
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.594 439.043l21.098 3.649 4.388-31.635z",
    fill: "red",
    stroke: "none",
    strokeOpacity: 1,
    paintOrder: "stroke fill markers",
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.629 457.562l63.099-39.156-56.648-7.35z",
    fill: "red",
    stroke: "none",
    strokeOpacity: 1,
    paintOrder: "stroke fill markers",
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.8 456.176l-1.488-3.637-14.346 3.455z",
    fill: "red",
    stroke: "none",
    strokeOpacity: 1,
    paintOrder: "stroke fill markers",
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.312 452.539l1.985-.176-.497 3.813z",
    fill: "red",
    stroke: "none",
    strokeOpacity: 1,
    paintOrder: "stroke fill markers",
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.629 457.562l63.099-39.156-3.543 27.157z",
    fill: "red",
    stroke: "none",
    strokeOpacity: 1,
    paintOrder: "stroke fill markers",
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.297 452.363l.888-6.8-59.556 12z",
    fill: "red",
    stroke: "none",
    strokeOpacity: 1,
    paintOrder: "stroke fill markers",
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.58 320.217l46.414-85.28 3.594 85.279z",
    fill: "#f1bfbf",
    stroke: "none",
    strokeOpacity: 1,
    paintOrder: "stroke fill markers",
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.382 148.767l56.878-14.777-23.255-46.37z",
    fill: "#f1bfbf",
    stroke: "none",
    strokeOpacity: 1,
    paintOrder: "stroke fill markers",
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.755 315.93l10.795-20.989 39.376 16.952z",
    fill: "#f1bfbf",
    stroke: "none",
    strokeOpacity: 1,
    paintOrder: "stroke fill markers",
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.836 259.38l21.09 52.513-39.377-16.952z",
    fill: "#f1bfbf",
    stroke: "none",
    strokeOpacity: 1,
    paintOrder: "stroke fill markers",
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.123 206.962l57.713 52.417-19.317-48.099z",
    fill: "#f1bfbf",
    stroke: "none",
    strokeOpacity: 1,
    paintOrder: "stroke fill markers",
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.35 251.467l79.486 7.912-57.713-52.417z",
    fill: "#f1bfbf",
    stroke: "none",
    strokeOpacity: 1,
    paintOrder: "stroke fill markers",
    stopColor: "#000"
  }))));
};
export default SvgBoat;